const {
  VUE_APP_API_URL: API_BASE_URL,
  VUE_APP_SOCKET_URL: SOCKET_URL,
  VUE_APP_API_STATIC_URL: API_BASE_URL_STATIC,
} = process.env;

export * as ENDPOINTS from './endpoints';

export { API_BASE_URL, SOCKET_URL, API_BASE_URL_STATIC };
